import { ExternalLink } from '@localstack/constants';
import { EmulatorType } from '@localstack/types';
import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ArrowOutward } from '@mui/icons-material';

const CoverageLink = styled(Link)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  paddingLeft: '4px',
}));

const SERVICE_COVERAGE_LINKS: Record<EmulatorType, ExternalLink> = {
  [EmulatorType.AWS]: ExternalLink.DOCS_FEATURE_COVERAGE,
  [EmulatorType.SNOWFLAKE]: ExternalLink.SNOWFLAKE_SERVICE_COVERAGE,
  [EmulatorType.AZURE]: ExternalLink.AZURE_SERVICE_COVERAGE,
};

export const ServiceCoverageLink = ({ emulator }: { emulator: EmulatorType }): JSX.Element => (
  <>
    To explore the catalog of cloud services we emulate,
    <CoverageLink href={SERVICE_COVERAGE_LINKS[emulator]} target="_blank" underline="hover">
      click here <ArrowOutward fontSize="small" />
    </CoverageLink>
  </>
);
